module.exports = "pegasus/assets/blocks/capture-1-themecapture1.png";